import script from "./ListVarian.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListVarian.vue?vue&type=script&lang=ts&setup=true"

import "./ListVarian.vue?vue&type=style&index=0&id=02479bbd&lang=css"

const __exports__ = script;

export default __exports__